/**
 * Dates as a reader of a log wants them.
 *
 * Its own module rather than an export of whichever page happened to need it first:
 * `DayRow` and `DayPage` both use it, and importing a helper from a page means importing
 * a page that is not being rendered.
 */

/** Whole days between two ISO dates. Positive when `date` is in the past. */
export function daysBefore(date: string, today: string): number {
  return Math.round(
    (Date.parse(`${today}T00:00:00Z`) - Date.parse(`${date}T00:00:00Z`)) / 86_400_000,
  );
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "Yesterday", or a written date. Absolute beats "3 days ago" for checking a log. */
export function relativeDay(date: string, today: string): string {
  const days = daysBefore(date, today);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  const [y, m, d] = date.split("-").map(Number) as [number, number, number];
  const month = MONTHS[m - 1];
  const thisYear = today.slice(0, 4) === String(y);
  return thisYear ? `${d} ${month}` : `${d} ${month} ${y}`;
}
